<template>
  <div class="matterH5">
    <div class="tab">
      <div class="header">
        <div
          class="list"
          v-for="(item, index) in navigationList"
          :key="index"
          @click="navigationHit(index, item)"
        >
          {{ item.title }}
        </div>
      </div>

      <div class="hint">
        © 2025 Mingteng International Corp Inc. All Rights Reserved.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navigationList: this.$store.state.navigationList,
    };
  },
  methods: {
    navigationHit(index, item) {
      this.navigationActive = index;
      this.navigationShow = false;

      this.$router.push({
        path: item.path,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.matterH5 {
  .tab {
    padding: 30px 10px;
    box-sizing: border-box;
    background: #30353e;

    .header {
      display: flex;
      flex-wrap: wrap;
      .list {
        width: calc(100% / 2);
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        text-align: left;
        margin-bottom: 10px;
      }
    }

    .hint {
      margin-top: 30px;
      font-size: 16px;
      font-weight: 500;
      color: #fff;
    }
  }
}
</style>